import $, { map } from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import fb from "@bd-core/firebase";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import Screen from "@bd-utils/screen";
import { dispatch, getState } from "@bd-stores/store";
import {
    getRoomStatus,
    getPlayers,
    getFinalTeamAnswers,
    getRoomScore,
    getRoomLogo,
    getRoomStatuses,
    setCurrentChallengeIndex,
    getLogos,
    getLeader,
} from "@bd-stores/game-progress";
import {
    setGameFinished,
    updateFinalRoomAnswer,
} from "@bd-core/firebase-actions";
import bdapi from "@bd-core/bd-api";
import gsap from "gsap";
import Draggable from "gsap/Draggable";
import { getRoomById } from "@bd-stores/game-data";
import { isTestMode } from "@bd-utils/test-mode";

export class MainRoom extends BD_Component {
    constructor() {
        super();

        this.id = "main-room";
        this.templateID = "main-room-template";

        this.elms = {
            btnFinishGame: ".js-finish-game",
            background: ".js-screen-img",
            backgroundImage: ".screen__img",
            zoomIn: ".js-zoom-in",
            zoomOut: ".js-zoom-out",
            hintItem: ".js-hint",
            audioItem: ".js-audio",
            audioItemFile: ".js-audio-file",
            scorePercentage: ".js-percentage",
            pseudoButton: ".js-pseudo-button",
            acceptLeaderBtn: ".js-switch-leader-button",
        };

        this._events = this.getEvents();
        this.fbListeners = [];

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.backgroundWidth = 5760;
        this.backgroundHeight = 2160;
        this.isTeamLeader = CONFIG.game.is_leader;
        this.logos = {};
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.btnFinishGame,
                handler: this.finishGame,
            },
            {
                event: "click",
                selector: elms.zoomIn,
                handler: this.onZoomIn,
            },
            {
                event: "click",
                selector: elms.zoomOut,
                handler: this.onZoomOut,
            },
            {
                event: "change",
                selector: elms.hintItem,
                handler: this.onClickedHint,
            },
            {
                event: "click",
                selector: elms.audioItem,
                handler: this.onClickAudio,
            },
            {
                event: "click",
                selector: elms.pseudoButton,
                handler: this.toggleLeaderSwitchPage,
            },
            {
                event: "click",
                selector: elms.acceptLeaderBtn,
                handler: this.leaderSwitchHandler,
            },
        ];
    }

    beforeInit() {
        window.screenCalculationFunc = () => Screen.calculateCoverSize();

        this.render();
        this.setGameState();
        this.listenFinishedUsers();
    }

    modifiedData() {
        const data = this._data;

        if (Object.keys(data).length == 0) return {};

        map(data.rooms, (room) => {
            let is_main_room = false;

            if (room.hotspot_type == "room") {
                is_main_room = true;
            }

            if (room.hotspot_type == "hint") {
                const font_fam = room.hint_font_family.split("|");
                const font_name = font_fam[0];
                const font_category = font_fam[1];

                room.font_family = `"${font_name}", ${font_category}`;
            }

            room.isMainRoom = is_main_room;

            return room;
        });

        let data_rooms = [];
        let team_dashboard = {};
        let totalCrystals = 0;

        data.rooms.forEach((room) => {
            if (room.mainroom_id == data.room_id) {
                /* get silicon crystals (currency) */
                const roomScore = getRoomScore(room.room);
                totalCrystals = totalCrystals + Number(roomScore);

                /* get team dashboard customization */
                const logoCustomization = getRoomLogo(room.room);
                if (logoCustomization) {
                    const roomId = room.room;

                    team_dashboard = {
                        ...team_dashboard,
                        [roomId]: {
                            image: logoCustomization,
                            layer_level: room?.customization?.layer_level || 0,
                        },
                    };
                }

                /* hide teamconnector room button */
                if (room.type === "teamconnector_room") room["isHidden"] = true;

                data_rooms.push(room);
            }
        });

        return {
            ...data,
            rooms: data_rooms,
            total_cystals: totalCrystals,
            team_dashboard: team_dashboard,
        };
    }

    render() {
        const data = this.modifiedData();
        const mainroomStyle = data.mainroom_style;
        let templateID = "main-room-template";

        if (typeof mainroomStyle == "string") {
            templateID = mainroomStyle + "-template";
        }

        const htmlTemplate = $("#" + templateID).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);

        // hide popups on main room
        $(".js-popup-timerhint").removeClass("is-open");
        $(".js-room-completion").removeClass("is-open");
        $(".js-info-popup").removeClass("active");
        $(".js-narrative-popup").removeClass("active");
    }

    setGameState() {
        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        const usersStateFinish = getFinalTeamAnswers(roomID);

        if (usersStateFinish) {
            const finishState = bdjs.indexedObjectToArray(usersStateFinish);
            const myState = finishState.find((uID) => uID == currentPlayerId);

            if (myState) {
                const waitingText = $(".waiting-others-text").text();
                const $finishBtn = $(this.elms.btnFinishGame);

                $finishBtn.addClass("is-waiting");
                $finishBtn.find("span").text(waitingText);
            }
        }

        const gameProgress = getState().gameProgress;
        const roomStatuses = gameProgress.roomStatus;
        const isAllRoomCompleted = gameProgress.allRoomCompleted;

        if (
            Object.keys(gameProgress.logos).length !==
            Object.keys(this.logos).length
        ) {
            this.logos = gameProgress.logos;
            this.updateLogos();
        }

        const rooms = CONFIG.game.rooms;
        const excludedRooms = ["main-room", "teamconnector_room"];
        const challangeRooms = rooms.filter(
            (item) => !excludedRooms.includes(item.type),
        );
        let completedRooms = [];

        $.each(roomStatuses, function (roomID, status) {
            if (isTestMode()) {
                return true;
            }

            if (status == "is-status-completed") {
                const room = getRoomById(roomID);
                // @ts-ignore
                const isTeamConnector = room?.type === "teamconnector_room";
                if (!isTeamConnector) completedRooms.push(roomID);

                $(`.js-room-item[data-page="${roomID}"]`).addClass(
                    "is-finished",
                );
            }
        });

        /* set score percentage */
        const totalRooms = challangeRooms.length;
        const completedRoomsTotal = completedRooms.length;
        const scorePercentage = (completedRoomsTotal / totalRooms) * 100;
        const $percentage = $(this.elms.scorePercentage);
        const percentageTxt = `${Math.round(scorePercentage)}%`;
        $percentage.text(percentageTxt);

        if (isAllRoomCompleted) {
            $("#page-mainroom").addClass("is-room-completed");
        }

        this.updateRoomRequirements();

        $(this.elms.backgroundImage).on("load", () => {
            if ($(this.elms.backgroundImage).hasClass("js-draggable")) {
                this.initBackground();
                this.setMoveable();
                $(window).on("resize", () => {
                    this.resetDraggableParams();
                });
            }
        });
    }

    // ============================== CUSTOM FUNCTION

    updateLogos() {
        const logos = getLogos();
        const rooms = CONFIG.game.rooms;
        let logoHtml = "";
        for (let key in logos) {
            const room = rooms.find((r) => r.id == key);
            if (room) {
                const layerLevel = room.customization?.layer_level || 0;
                logoHtml += `<img class="placeholder" src="${logos[key]}" style="z-index:${layerLevel}" />`;
            }
        }

        $("#room-logos").html(logoHtml);
    }

    initBackground() {
        let backWidth = $(this.elms.backgroundImage).prop("naturalWidth"),
            backHeight = $(this.elms.backgroundImage).prop("naturalHeight");
        this.backgroundWidth = !backWidth ? 4096 : backWidth;
        this.backgroundHeight = !backHeight ? 1536 : backHeight;
        setTimeout(() => {
            $(this.elms.backgroundImage).removeAttr("style");
            $(this.elms.background).removeAttr("style");
            $(".js-draggable").css({
                width: `${this.backgroundWidth}px`,
                height: `${this.backgroundHeight}px`,
            });
        }, 400);
    }

    resetDraggableParams() {
        $(".js-draggable").css({
            width: `${this.backgroundWidth}px`,
            height: `${this.backgroundHeight}px`,
            transform: `translate(-50%, -50%)`,
        });
        this.startX = 0;
        this.startY = 0;
        gsap.set(".js-draggable", { clearProps: "transform" });
    }

    onZoomIn() {
        if (this.zoom < 120) {
            this.zoom += 5;
            this.backgroundWidth += this.backgroundWidth * 0.05;
            this.backgroundHeight += this.backgroundHeight * 0.05;
            this.resetDraggableParams();
        }
    }

    onZoomOut() {
        if (this.zoom > 100) {
            this.zoom -= 5;
            this.backgroundWidth -= this.backgroundWidth * 0.05;
            this.backgroundHeight -= this.backgroundHeight * 0.05;
            this.resetDraggableParams();
        }
    }

    leaderSwitchHandler() {
        // const memberList = [0, 1, 2, 3, 4, 5];
        // const $leaderSwitchIndicator = $(".js-leader-indicator");
        // const $leaderSwitchBtn = $(".js-switch-leader-button");
        // console.log(this.isTeamLeader);
        // // not sure of where and how do we manage to edit team leader. but here is a glimpse of logic to change leader position
        // if (this.isTeamLeader) {
        //     $leaderSwitchBtn.addClass("active");
        // }
        // // indicator position, from this example 3 is the index of current leader.
        // $(".js-leader-indicator").css({
        //     transform: `translateX(${memberList[1]}00%)`,
        // });
    }

    toggleLeaderSwitchPage() {
        // const $leaderSwitchSelector = $(".js-leader-switch");
        // const currentImageUrl = `${CONFIG.themeURL}/assets/images/m2m-dashboard-new.png`;
        // const newImageUrl = `${CONFIG.themeURL}/assets/images/m2m-default-right.png`;
        // const $leaderSwitchBtn = $(".js-switch-leader-button");
        // $leaderSwitchSelector.toggleClass("active");
        // if (this.isTeamLeader) {
        //     $leaderSwitchBtn.addClass("active");
        // }
        // // change state for team leader
        // // to change background on toggle switch
        // if ($leaderSwitchSelector.hasClass("active")) {
        //     $(".screen__img").attr("src", newImageUrl);
        // }
        // if (!$leaderSwitchSelector.hasClass("active")) {
        //     $(".screen__img").attr("src", currentImageUrl);
        // }
    }

    setMoveable() {
        gsap.registerPlugin(Draggable);
        let companions;

        Draggable.create(".js-draggable", {
            bounds: $(".screen__container"),
            dragResistance: 0.5,
            edgeResistance: 1,
            allowContextMenu: true,
            type: "x,y",
            zIndexBoost: false,
            onPress: function () {
                const screens = document.querySelectorAll(".js-draggable");
                let i = screens.length;
                companions = [];
                MainRoom.prototype.startX = this.x;
                MainRoom.prototype.startY = this.y;
                while (--i > -1) {
                    if (companions[i] !== this.target) {
                        companions.push({
                            element: screens[i],
                            x: gsap.getProperty(screens[i], "x"),
                            y: gsap.getProperty(screens[i], "y"),
                        });
                    }
                }
                gsap.killTweensOf(".js-draggable");
            },
            onDrag: function () {
                let i = companions.length,
                    deltaX = this.x - MainRoom.prototype.startX,
                    deltaY = this.y - MainRoom.prototype.startY,
                    companion;
                while (--i > -1) {
                    companion = companions[i];
                    gsap.set(companion.element, {
                        x: companion.x + deltaX,
                        y: companion.y + deltaY,
                    });
                }
            },
        });
    }

    updateRoomRequirements() {
        const rooms = CONFIG.game.rooms;
        const roomStatuses = getRoomStatuses();
        const startedIds = Object.keys(roomStatuses).map((k) => parseInt(k));

        let lastChallengeId = 0;
        let lastChallengeIndex = 0;
        if (startedIds.length) {
            rooms.forEach((room, index) => {
                const roomId = parseInt(room.id.toString());
                if (isNaN(roomId)) {
                    return true;
                }

                if (startedIds.includes(roomId)) {
                    lastChallengeIndex = index;
                    lastChallengeId = roomId;
                }
            });
        }

        $.each(rooms, (i, room) => {
            if (isTestMode()) {
                return;
            }

            const requirements = room.requirements;
            const $roomItem = $(`.js-room-item[data-page="${room.id}"]`);

            $roomItem.removeClass("is-notready is-ready");

            // if (!requirements.length) {
            //     $roomItem.addClass("is-ready").prop("disabled", false);
            //     return true;
            // }

            let isLocked = false;
            $.each(requirements, (j, roomID) => {
                const roomStatus = getRoomStatus(roomID);

                if (roomStatus !== "is-status-completed") {
                    isLocked = true;
                    return false;
                }
            });

            // set playable challenge
            if (lastChallengeIndex > -1) {
                const lastRoomStatus = getRoomStatus(lastChallengeId);
                const roomToBePlayedIndex =
                    lastRoomStatus === "is-status-completed"
                        ? lastChallengeIndex + 1
                        : lastChallengeIndex;
                if (roomToBePlayedIndex === i) {
                    $roomItem.addClass("is-now-playing");
                    dispatch(setCurrentChallengeIndex(roomToBePlayedIndex));
                } else if (i > roomToBePlayedIndex) {
                    isLocked = true;
                } else {
                    $roomItem.addClass("is-finished").prop("disabled", true);
                }
            }

            isLocked
                ? $roomItem
                      .addClass(["is-notready is-locked"])
                      .prop("disabled", true)
                : $roomItem.addClass("is-ready").prop("disabled", false);
        });
    }

    finishGame(e, el) {
        const $el = $(el);
        const roomID = this.roomId;
        const gameProgress = getState().gameProgress;
        const waitingText = $(".waiting-others-text").text();

        if (gameProgress.allRoomCompleted && !$el.hasClass("is-waiting")) {
            $el.addClass("is-waiting");
            $el.find("span").text(waitingText);

            updateFinalRoomAnswer(roomID, {
                [CONFIG.user.id]: CONFIG.user.id,
            });

            this.maybeReadyToFinish();
        }
    }

    async finishedUsersListener(snapshot) {
        if (this === null) return;

        const value = snapshot.val();
        const readyUsers = bdjs.indexedObjectToArray(value);
        const players = getPlayers();
        const roomData = this.modifiedData();
        const { total_cystals, team_dashboard } = roomData;
        let customizations = [];
        Object.keys(team_dashboard).forEach(
            (key) =>
                (customizations = {
                    ...customizations,
                    [key]: team_dashboard[key].image,
                }),
        );

        const leaderId = getLeader();

        if (readyUsers.length) {
            let allReady = true;

            players.forEach((player) => {
                const isReady = readyUsers.find((id) => id == player.userId);
                if (player.isOnline && !isReady) allReady = false;
            });

            if (allReady) {
                await bdjs.goAsync(
                    bdapi.post("game/finish-game", {
                        middle_state: getState().gameProgress.isMiddleState
                            ? 1
                            : 0,
                        score: total_cystals,
                        team_dashboard: customizations,
                        leader: leaderId,
                    }),
                );

                setGameFinished();
            }
        }
    }

    maybeReadyToFinish() {
        const roomID = this.roomId;
        fb.get(`${fb.roomsPath}/${roomID}/finalAnswers`).then((data) => {
            this.finishedUsersListener(data);
        });
    }

    listenFinishedUsers() {
        const roomID = this.roomId;
        const path = `${fb.roomsPath}/${roomID}/finalAnswers`;

        this.fbListeners.push(
            fb.onValue(path, this.finishedUsersListener),
            fb.onValue(fb.playersPath, this.maybeReadyToFinish.bind(this)),
        );
    }

    beforeDestroy() {
        this.fbListeners.forEach((fn) => fn.call());
        this.fbListeners = [];
    }

    onClickedHint(e, el) {
        const elms = this.elms;
        const thisId = $(el).attr("id");
        const hintHotspots = $(elms.hintItem);

        $.each(hintHotspots, (index, item) => {
            const $item = $(item);
            const itemID = $item.attr("id");

            if (itemID !== thisId) {
                $item.prop("checked", false);
            }
        });
    }

    onClickAudio(e, el) {
        const elms = this.elms;
        const thisId = $(el).attr("id");
        const audioHotspot = $(elms.audioItem);

        $(elms.hintItem).prop("checked", false);

        const currentAudioID = "#" + thisId.split("audio-")[1];
        const $currAudio = $(currentAudioID).get(0);
        const isPlaying = $(el).hasClass("is-playing");

        // @ts-ignore
        isPlaying ? $currAudio.pause() : $currAudio.play();

        $(el).toggleClass("is-paused", isPlaying);
        $(el).toggleClass("is-playing", !isPlaying);

        $.each(audioHotspot, (index, item) => {
            const $item = $(item);
            const itemID = $item.attr("id");

            const audioID = "#" + itemID.split("audio-")[1];
            const $audio = $(audioID).get(0);

            if (itemID !== thisId) {
                // @ts-ignore
                if ($audio.play()) $audio.pause();

                $item.addClass("is-paused");
                $item.removeClass("is-playing");
            }
        });
    }
}
